// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"4a85f856","629":"6051f7b7","924":"7e03bd04"}[chunkId] + ".chunk.css";
};